
        module.exports = __webpack_public_path__ + "assets/images/logo-be.a011efd3.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 300,
            height: 222,
            type: "png",
            bytes: 17331,

            toString: function() {
                return src;
            }
        };
    